import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import {HistoryStore} from 'src/app/modules/core/store';

import {BlockActivityInfoUpdatedBy, VehicleHistoryEvent} from 'src/app/modules/shared/models/vehicle-history';

import * as _ from 'lodash';
import { MomentModule } from 'ngx-moment';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

@Component({
    selector: 'app-activity-card',
    templateUrl: './activityCard.component.html',
    styleUrls: ['./activityCard.component.scss'],
    imports: [MatRippleModule, TranslateModule, NgStyle, NgTemplateOutlet, MomentModule],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ActivityCardComponent implements OnChanges {
    private _historyStore = inject(HistoryStore);

    @Input() data: VehicleHistoryEvent;
    @Input() isActive = false;

    public info: any;
    public cardType: string;


    constructor() { }

    ngOnChanges(simpleChanges: SimpleChanges) {
        if (simpleChanges.data) {
            this.info = this.data;
            this.cardType = this.data.type;
        }
    }

    public eventClick(event: VehicleHistoryEvent) {
        const firstPos = _.chain(event?.positionTimestamps).sort().first().value();
        this._historyStore.highlightByTimeStampString(firstPos, BlockActivityInfoUpdatedBy.cardClick);
    }

    public timestampClick(positionTimestamp: string) {
        this._historyStore.highlightByTimeStampString(positionTimestamp, BlockActivityInfoUpdatedBy.cardClick);
    }

    public activityEventClicked() {
        if (this.data?.positionTimestamps?.length > 0) {
            const firstPos = _.chain(this.data?.positionTimestamps).sort().first().value();
            this._historyStore.highlightByTimeStampString(firstPos, BlockActivityInfoUpdatedBy.cardClick);
        }
    }
}
